if (!customElements.get('thumbnail-gallery')) {
  customElements.define(
    'thumbnail-gallery',
    class ThumbnailGallery extends HTMLElement {
      constructor() {
        super();

        this.thumbnailWrapper = this;
        this.thumbnailImages = this.thumbnailWrapper.querySelectorAll('.product-thumbnails__item');
        this.galleryImages = document.querySelectorAll('media-gallery .product__media-item');

        this.imageObserver(this.galleryImages);

        this.thumbnailImages.forEach((elem) => {
          elem.addEventListener('click', (event) => {
            const container = event.currentTarget.closest('.product__media-wrapper').querySelector('.product-images');
            const targetElem = container.querySelector(`[data-media-id='${event.currentTarget.getAttribute('data-media-id')}']`);
            container.scrollTo({ top: targetElem.offsetTop - 1, behavior: 'smooth' });
          });
        });
      }

      // Set up IntersectionObservers for main product images
      imageObserver(galleryImages) {
        galleryImages.forEach((image) => {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.scrollThumbnail(image); // Scroll the corresponding thumbnail
                }
              });
            },
            { threshold: 0.5 },
          );
          observer.observe(image); // Start observing the image
        });
      }

      // Scroll the corresponding thumbnail when the main product image is in view
      scrollThumbnail(image) {
        let intersectingThumbnail;
        this.thumbnailImages.forEach((thumbnailImage) => {
          if (thumbnailImage.getAttribute('data-media-id') == image.getAttribute('data-media-id')) {
            intersectingThumbnail = thumbnailImage;
            return;
          }
        });

        if (intersectingThumbnail) {
          const thumbnailWrapper = this.parentElement;
          const thumbnailWrapperOffset = thumbnailWrapper.offsetTop;
          const style = window.getComputedStyle(intersectingThumbnail);
          const imageHeightInclMargin = intersectingThumbnail.offsetHeight + Number(style.getPropertyValue('margin-bottom').match(/\d+/)[0]);

          // Scroll the thumbnail wrapper smoothly to the intersecting thumbnail
          thumbnailWrapper.scrollTo({
            top: intersectingThumbnail.offsetTop - thumbnailWrapperOffset - imageHeightInclMargin,
            behavior: 'smooth',
          });
        }
      }
    },
  );
}
